//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
  StringService,
  StoreFrontSponsorStorageService,
  PersonalOfferStorageService
} from '@nuskin/ns-util';
import {isNullOrEmpty} from '@nuskin/ns-common-lib';
import webLoyalty from '@nuskin/ns-loyalty-web';

export default {
  name: 'LoyaltyInformation',
  props: {
    marketAttributes: {
      type: Object,
      required: true
    },
    maxQuantity: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      hideLoyalty: false,
      isOptedIn: false,
      loyaltyStatusAndLinks: {}
    };
  },
  computed: {
    traditionalLocale() {
      return this.$store.getters['nuskin/traditionalLocale'] || '';
    },
    marketConfig() {
      return this.$store.state.nuskin.marketConfig || {};
    },
    siteUrl() {
      return this.$store.getters['nuskin/siteUrl'] || '';
    },
    isLoggedIn() {
      return this.$store.state.user.isLoggedIn;
    },
    isMarketEnabled() {
      return !!this.loyaltyStatusAndLinks.enabled;
    },
    productLoyalty() {
      return this.marketAttributes || {};
    },
    canProductEarn() {
      return !!this.productLoyalty.earn;
    },
    canProductRedeem() {
      return !!this.productLoyalty.redeem;
    },
    isProductEnabled() {
      return this.canProductEarn || this.canProductRedeem;
    },
    isLoyaltyEnabled() {
      return !this.hideLoyalty && this.isMarketEnabled && this.isProductEnabled;
    },
    coinColor() {
      return this.isLoggedIn &&
        this.isOptedIn &&
        (!this.canProductEarn || !this.canProductRedeem)
        ? 'green'
        : 'blue';
    },
    coinUrl() {
      return `${this.siteUrl}/content/dam/apps/loyalty/global/loyalty_coin_${this.coinColor}.svg`;
    },
    landingUrl() {
      return `${this.siteUrl}${this.loyaltyStatusAndLinks.landingPage}`;
    },
    dashboardUrl() {
      return `${this.siteUrl}${this.loyaltyStatusAndLinks.dashboardPage}`;
    },
    notOptedInMessage() {
      return this.loyaltyStatusAndLinks.notOptedIn || '';
    },
    dashboardLinkMessage() {
      if (this.canProductEarn && this.canProductRedeem) {
        return this.loyaltyStatusAndLinks.productOptedInEarnAndRedeem;
      }
      return this.canProductEarn
        ? this.loyaltyStatusAndLinks.productOptedInEarnNotRedeem
        : this.loyaltyStatusAndLinks.productOptedInRedeemNotEarn;
    },
    rewardsUrl() {
      return this.isLoggedIn && this.isOptedIn
        ? this.dashboardUrl
        : this.landingUrl;
    },
    rewardsMessage() {
      return this.isLoggedIn && this.isOptedIn
        ? this.dashboardLinkMessage
        : this.notOptedInMessage;
    }
  },
  watch: {
    async marketAttributes() {
      await this.setLoyalty();
    },
    async maxQuantity() {
      await this.setLoyalty();
    },
    async isLoyaltyEnabled() {
      await this.setLoyaltyStrings();
    }
  },
  async mounted() {
    await this.setLoyalty();
  },
  methods: {
    async setLoyalty() {
      const isPersonalOffer = PersonalOfferStorageService.isPersonalOffer();
      const isStorefront = StoreFrontSponsorStorageService.isStorefront();
      this.hideLoyalty = isPersonalOffer || isStorefront;

      const localLoyaltyData =
        JSON.parse(localStorage.getItem('loyaltyData')) || null;

      // Making sure they are not already opted in and we have already set hide loyalty
      if (
        localLoyaltyData &&
        !localLoyaltyData.optInStatus &&
        !this.hideLoyalty
      ) {
        this.hideLoyalty = !(await webLoyalty.loyaltyCanOptIn());
      }

      this.loyaltyStatusAndLinks = {
        ...this.loyaltyStatusAndLinks,
        ...this.marketConfig.loyalty
      };
    },

    async setLoyaltyStrings() {
      // Check if loyalty is on for the market and not personal offer or mysite, coming from computed value, also checks hideLoyalty
      if (this.isLoyaltyEnabled) {
        // String Defaults
        this.loyaltyStatusAndLinks = {
          ...this.loyaltyStatusAndLinks,
          landingPageLinkMessage: 'Your enJoy Rewards are waiting!',
          dashboardLinkMessage: 'enJoy Rewards available!',
          notOptedIn: 'Your enJoy Rewards are waiting',
          productOptedInEarnAndRedeem:
            '{earnPercentage} enJoy Rewards available!',
          productOptedInEarnNotRedeem: 'Earn with Nu Skin Rewards',
          productOptedInRedeemNotEarn: 'Save with Nu Skin Rewards'
        };

        const loyaltyStrings = await StringService.getApplicationStrings(
          'loyalty'
        );
        if (!isNullOrEmpty(loyaltyStrings)) {
          // Link message to show to non-opted in users
          if (loyaltyStrings.productDisplayNotOptedinMessage) {
            this.loyaltyStatusAndLinks = {
              ...this.loyaltyStatusAndLinks,
              landingPageLinkMessage:
                loyaltyStrings.productDisplayNotOptedinMessage,
              notOptedIn: loyaltyStrings.productDisplayNotOptedinMessage
            };
          }

          // Get loyalty information for user
          const userLoyalty = webLoyalty.getLoyaltyRewardsPoints() || {};
          this.isOptedIn = !!userLoyalty.optInStatus;

          if (this.isOptedIn) {
            if (loyaltyStrings.productDisplayOptedinMessage) {
              let earnPercentage = '';
              if (
                userLoyalty.userTier &&
                userLoyalty.userTier.purchaseRatio &&
                !isNaN(userLoyalty.userTier.purchaseRatio)
              ) {
                earnPercentage =
                  Number(
                    Number(userLoyalty.userTier.purchaseRatio * 100).toFixed(2)
                  ) + '%';
              }

              this.loyaltyStatusAndLinks = {
                ...this.loyaltyStatusAndLinks,
                dashboardLinkMessage: loyaltyStrings.productDisplayOptedinMessage.replace(
                  /\{earnPercentage\}/g,
                  earnPercentage
                ),
                productOptedInEarnAndRedeem: loyaltyStrings.productDisplayOptedinMessage.replace(
                  /\{earnPercentage\}/g,
                  earnPercentage
                )
              };
            }

            if (loyaltyStrings.productOptedInEarnNotRedeem) {
              this.loyaltyStatusAndLinks = {
                ...this.loyaltyStatusAndLinks,
                productOptedInEarnNotRedeem:
                  loyaltyStrings.productOptedInEarnNotRedeem
              };
            }

            if (loyaltyStrings.productOptedInRedeemNotEarn) {
              this.loyaltyStatusAndLinks = {
                ...this.loyaltyStatusAndLinks,
                productOptedInRedeemNotEarn:
                  loyaltyStrings.productOptedInRedeemNotEarn
              };
            }
          }
        }

        this.loyaltyStatusAndLinks = {
          ...this.loyaltyStatusAndLinks,
          dashboardPage: this.localeReplace(
            this.loyaltyStatusAndLinks.dashboardPage
          ),
          landingPage: this.localeReplace(
            this.loyaltyStatusAndLinks.dashboardPage
          )
        };
      } else {
        this.hideLoyalty = true;
      }
    },

    localeReplace(url) {
      return url
        .replace(/\{locale\}/g, this.traditionalLocale)
        .replace(' ', '');
    }
  }
};
